<template>
  <div class="distribution-wrapper">
    <app-markets-nav :navItems="navItems"></app-markets-nav>
    <div class="distribution-content">
      <h4 class="distribution-h4 indent" id="distribution-1">Standard strips and sheets</h4>
      <p class="distribution-p indent">Aluminium’s light weight, good corrosion resistance and formability make it an excellent engineering material with a variety of applications in all industrial sectors. Standard aluminium strips and sheets are usually supplied to distributors and service centers for subsequent use in construction, electrotechnical industry and other industrial sectors.</p>
      <div class="distribution-img" :style="{backgroundImage: 'url(' + '/static/img/markets/distribution/img_1.jpg' + ')'}"></div>
      <h4 class="distribution-h4 indent" id="distribution-2">Standard profiles</h4>
      <p class="distribution-p indent">Profiles with standard shapes (square/rectangular/round tubes, square/rectangular/round bars, angles, T-profiles, U-profiles, Z-profiles, H-profiles) are usually supplied to distributors to be used for a variety of applications, mainly in building and construction. Alcomet has over 1400 different sizes available.</p>
      <div class="distribution-img" :style="{backgroundImage: 'url(' + '/static/img/markets/distribution/img_2.jpg' + ')'}"></div>
      <app-share-button></app-share-button>
    </div>
  </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
import MarketsNav from "./MarketsNav";
export default {
  components: {
    appShareButton: ShareButton,
    appMarketsNav: MarketsNav
  },
  data() {
    return {
      navItems: [
        ["distribution-1", "Standard strips and sheets"],
        ["distribution-2", "Standard profiles"]
      ]
    };
  }
};
</script>

<style scoped>
.distribution-wrapper {
  align-items: center;
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
}
/* CONTENT */
.distribution-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 80%;
}
.distribution-p {
  font-size: 19px;
  margin: 15px 0;
  text-align: justify;
  line-height: 32px;
  width: 60%;
}
.distribution-link {
  font-size: 19px;
  text-decoration: underline;
}
.distribution-h4 {
  font-size: 22px;
  font-weight: 500;
  line-height: 32px;
  margin: 15px 0;
  text-align: justify;
  width: 60%;
}
.distribution-img {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 5px;
  min-height: 280px;
  margin: 20px 0;
  width: 80%;
}
@media screen and (max-width: 1000px) {
  .distribution-content {
    width: 100%;
  }
  .distribution-h4 {
    font-size: 18px;
    padding: 0 30px;
    width: 100%;
  }
  .distribution-p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .distribution-link {
    font-size: 16px;
  }
  .distribution-img {
    min-height: 30vw;
    margin: 20px 30px;
    width: calc(100% - 60px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/markets/Distribution.vue